export const desktopMenu = () => {
  $('.site-navigation .menu > li > a').click(function () {
    $(this).toggleClass('is-active');
  });
  $('.site-navigation .menu > li.menu-item-has-children').hover(function () {
    $('body').toggleClass('menu-shown');
  });

  const $siteHeader = $('.site-header');

  let prevScrollY = 0;
  let prevScrollUp = 0;
  let prevScrollDown = 0;
  const threshold = 50;
  const headerHeight = 105;

  window.addEventListener('scroll', () => {
    const scrollY = window.pageYOffset;

    if (scrollY > headerHeight) {
      $siteHeader.addClass('in-body');
    } else {
      $siteHeader.removeClass('in-body');
    }

    // handle scroll down
    if (scrollY > prevScrollY) {
      if (!prevScrollDown) {
        prevScrollDown = scrollY;
        prevScrollUp = false;
      }

      if (scrollY > prevScrollDown + threshold) {
        $siteHeader.removeClass('is-visible');
      }
    }

    // handle scroll up
    if (scrollY < prevScrollY) {
      if (!prevScrollUp) {
        prevScrollUp = scrollY;
        prevScrollDown = false;
      }

      if (scrollY < prevScrollUp - threshold) {
        $siteHeader.addClass('is-visible');
      }
    }

    prevScrollY = scrollY;
  });
};
